















export default {
    name: 'Modal'
    props:
        title: false
        text: false
        show: false
    computed:
        showmodal: ()->
            ret = 'none'
            if @show
                ret = 'block'
            return ret
    methods:
        ok: ()->
            @$emit('modalconfirm')            
        dismiss: ()->
            @$emit('modaldissmiss')
}
